import { ReactNode } from "react";
import { View } from "./View";

interface IBalanceData {
  amount: number;
  currencySymbol: string;
  description: string;
}

interface IBalancesTableProps {
  data: IBalanceData[];
  title: string;
  subtitle: string;
  navigateButton: ReactNode;
  total: number;
  totalCurrencySymbol: string;
}

export const AvailableAndDisputeBalance = (props: IBalancesTableProps) => {
  return <View {...props} />;
};
